import {SxType} from "@baseTypes/sx/sxTypes";

/**
 * The tasks panel: a warm tray with the blocks sitting back up on page level.
 *
 * It used to be a lilac slab, a saturated hue that belonged to no theme and took
 * the largest surface on the screen, so every 14px state mark had to compete
 * with the wallpaper. This beige is the one value here that is not a palette
 * token, and deliberately so - the theme has no warm neutral, and a warm tray is
 * what puts the yellow tab in a family instead of on its own. It is low enough
 * in chroma to stay behind the white blocks and the state marks rather than
 * argue with them.
 */
export const sx: SxType = {
    inner: {
        width: '100%',
        paddingTop: '16px',
    },
    root: {
        padding: '26px 14px 14px',
        borderRadius: '12px',
        width: '100%',
        marginTop: '-16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        backgroundColor: 'rgba(255, 196, 140, 0.08)',
        border: '1px solid',
        borderColor: 'divider',
        '.lightTheme &': {backgroundColor: '#fbeee2'},
    },
    /**
     * The same tray on the left, where nothing hangs over its top edge and the
     * column cannot spare 26px of clearance for a tab that is not there.
     */
    rootSmall: {
        padding: '7px 9px',
        borderRadius: '8px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '1px',
        backgroundColor: 'rgba(255, 196, 140, 0.08)',
        border: '1px solid',
        borderColor: 'divider',
        '.lightTheme &': {backgroundColor: '#fbeee2'},
    },
    nothing: {},
    nothingText: {
        fontSize: '12px',
        display: 'block',
        width: '100%',
        color: 'text.secondary',
    },
    clearIcon: {
        width: '40px',
        height: '40px',
        color: 'text.disabled',
    },
    innerHeader: {
        paddingLeft: '13px',
        display: 'flex',
        gap: '10px',
        alignItems: 'center',
    },
    header: {
        backgroundColor: '#ffcb46',
        padding: '4px 14px 4px 8px',
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        height: '28px',
        borderRadius: '40px',
        zIndex: 55,
        position: 'relative',
        maxWidth: '170px',
    },
    headerTitle: {
        fontSize: '12px',
        fontWeight: 600,
        color: '#222',
    },
    headerIcon: {
        width: '18px',
        height: '18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    headerIconContent: {
        width: '16px',
        height: '16px',
        color: '#222',
    },
}
